import {
  useLocation,
  // HashRouter as Router,
} from "react-router-dom";
import { useEffect } from "react";

const HemaPage = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/alogrithm-configure") {
      let iframeUrl = /planogram.cpaxtra.co.th/.test(window.location?.host) ? "https://alg-planogram.cpaxtra.co.th" 
      : /dev/.test(window.location?.host)
        ? "http://alg-planogram-dev.cpaxtra.co.th"
        : "https://alg-plangram-uat.cpaxtra.co.th";

      window.open(iframeUrl);
    }
  }, [location]);

  return <></>;
};

export default HemaPage;
